__turbopack_context__.v({
  "layers": "_6zm7Aa_layers",
  "option": "_6zm7Aa_option",
  "optionName": "_6zm7Aa_optionName",
  "panel": "_6zm7Aa_panel",
  "replay": "_6zm7Aa_replay",
  "stage": "_6zm7Aa_stage",
  "switch": "_6zm7Aa_switch",
});
